import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  forwardRef,
  Input,
  OnInit,
  ViewChild
} from '@angular/core';
import { NG_VALUE_ACCESSOR, UntypedFormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { ReuseTabService } from '@delon/abc/reuse-tab';
import { _HttpClient, SettingsService } from '@delon/theme';
import { NzSelectComponent, NzSelectModeType } from 'ng-zorro-antd/select';

import { SelectBaseComponent } from '../select-base';
import { SelectInstantBaseComponent } from '../selectInstant-base';

@Component({
  selector: 'app-simple-stock-location-select',
  templateUrl: './stock-location-select.component.html',
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SimpleStockLocationSelectComponent),
      multi: true
    }
  ]
})
export class SimpleStockLocationSelectComponent
  extends SelectInstantBaseComponent
  implements OnInit, AfterViewInit
{
  @ViewChild('selector') nzSelectComponent!: NzSelectComponent;

  @Input() tabindex: string | null = null;
  @Input() mode: NzSelectModeType = 'default';
  @Input() skipRestrictions = false;

  NotShowInReport: boolean = false;

  constructor(
    http: _HttpClient,
    router: Router,
    cdr: ChangeDetectorRef,
    private resueTabService: ReuseTabService,
    private settingsService: SettingsService
  ) {
    super(http, cdr, router);
  }

  ngOnInit(): void {
    this.checkAddNewOptionInReportAccess();
  }

  ngAfterViewInit(): void {
    if (this.tabindex) {
      const nzSelectElement =
        this.nzSelectComponent.originElement.nativeElement;

      const searchInput = nzSelectElement.querySelector('input');

      if (searchInput) {
        searchInput.setAttribute('tabindex', this.tabindex?.toString() || '0');
      }
    }
  }

  //!default filter
  // getUrl(searchValue: string): string {
  //   let filter = `isActive eq true`;
  //   if (searchValue)
  //     return `api/stocklocations/lookup?$top=20&$skip=0&$orderby=code asc&$filter=${filter}&keyword=${encodeURIComponent(searchValue)}`;
  //   else
  //     return `api/stocklocations/lookup?$top=20&$skip=0&$orderby=code asc&$filter=${filter}`;
  // }

  //with uds
  getUrl(searchValue: string): string {
    // Start with base filter
    let filter = `isActive eq true`;

    // Add search filter
    if (searchValue && String(searchValue).trim()) {
      const searchStr = String(searchValue).replaceAll("'", "''");
      filter += ` and (contains(code, '${encodeURIComponent(searchStr)}') or contains(name,'${encodeURIComponent(searchStr)}'))`;
    }

    // Return final OData query
    let url = `api/stocklocations/lookup?$top=20&$skip=0&$orderby=code asc&$filter=${filter}`;
    if (this.skipRestrictions) {
      url += `&skipRestrictions=true`;
    }
    return url;
  }

  // set the location want to navigate
  jump(): string {
    return '/stk/location/';
  }

  // set the param
  queryParam(): String {
    return 'stockLocationId';
  }

  checkAddNewOptionInReportAccess(): boolean {
    let curUrl = this.resueTabService.curUrl.toLowerCase();

    if (curUrl.includes('report')) {
      this.NotShowInReport = true;
    } else {
      this.NotShowInReport = false;
    }

    return this.NotShowInReport;
  }

}
